import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { message, Select, Spin } from 'antd';
import PropTypes from 'prop-types';
import { getErrorMessages, getFields } from '../../../../constants/messages';
import { GetTechnicians } from '../../actions';
import '@ant-design/compatible/assets/index.css';

const FormItem = Form.Item;
const { Option } = Select;

let fieldMessages = getFields(),
	errorMessages = getErrorMessages();

const messages = {
	...fieldMessages,
	...errorMessages,
};

class Technicians extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
		};
	}

	componentDidMount() {
		const { props, getIntl, setLoading } = this;
		const { getTechnicians } = props;
		setLoading(true);
		getTechnicians()
			.then(() => setLoading(false))
			.catch(() => {
				setLoading(false);
				message.error(getIntl('techniciansLoadError'));
			});
	}

	getIntl = (str) => this.props.intl.formatMessage({ ...messages[str] });
	setLoading = (isLoading) => this.setState({ isLoading });

	onChange = (technicians) => {
		const { props } = this;
		const { onChange } = props;
		if ('onChange' in props) onChange(technicians);
	};

	buildOptions = () => {
		const { technicianList } = this.props;
		return technicianList.map((technician) => {
			const { id, name } = technician;
			return (
				<Option key={id} value={id}>
					{name}
				</Option>
			);
		});
	};

	parseInitialList = () => {
		const { technicians } = this.props;
		return technicians.map((technician) => {
			if (typeof technician === 'number') return technician;
			else return technician.id;
		});
	};

	render() {
		const { state, props, getIntl, buildOptions, parseInitialList, onChange } = this;
		const { isLoading } = state;
		const { form, disabled } = props;
		const { getFieldDecorator } = form;
		const options = buildOptions();
		const technicians = parseInitialList();
		return (
			<FormItem label={getIntl('technicians')}>
				{getFieldDecorator(`technicians`, {
					initialValue: technicians,
					rules: [
						{
							required: true,
							message: getIntl('techniciansError'),
						},
					],
					onChange: onChange,
				})(
					<Select
						className="job-full-component"
						showSearch
						mode={'multiple'}
						disabled={disabled}
						placeholder={getIntl('technicians')}
						optionFilterProp="children"
						filterOption={(input, option) =>
							option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
						}
						notFoundContent={isLoading ? <Spin size="small" /> : getIntl('notFound')}
						dropdownMatchSelectWidth={false}
					>
						{options}
					</Select>
				)}
			</FormItem>
		);
	}
}

Technicians.defaultProps = {
	technicians: [],
	disabled: false,
};

Technicians.propTypes = {
	intl: PropTypes.object.isRequired,
	getTechnicians: PropTypes.func.isRequired,
	technicianList: PropTypes.array.isRequired,

	form: PropTypes.object.isRequired,
	technicians: PropTypes.array,
	disabled: PropTypes.bool,
	onChange: PropTypes.func,
};

const mapStateToProps = (state) => {
	return {
		technicianList: state.job.technicianList,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getTechnicians: () => dispatch(GetTechnicians()),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Technicians));
